<style lang="less" scoped>
.contract-detail{
  width: 100%;
  position: relative;
  .contract-detail-menu{
    position: absolute;
    top: 0;
    right: 0;
    .local-main-link{
      font-size: 16px;
      line-height: 1.5715;
      text-decoration: none;
    }
  }
}
</style>

<template>
  <div class="contract-detail" v-if="id && detail" >
    <div class="contract-detail-menu">
      <p class="local-main-link" @click="showRentPlan">合同租金计划</p>
    </div>
    <DescriptionList :title="'合同基本信息'" :data="detail" :list="description" :extraData="extraData" :collapse="collapse" @collapse="onCollapseChange" >
      <template #triggerRepurchaseFlag>
        <a-select
          v-if="!unOperate"
          :class="detail.triggerRepurchaseFlag !== originDetail.triggerRepurchaseFlag ? 'local-main-danger-select' : ''"
          style="width: 100%;"
          v-model:value="detail.triggerRepurchaseFlag"
          :filter-option="false"
          :options="select.options"
          placeholder="请选择"
        />
        <span v-else>{{ detail.triggerRepurchaseFlag !== undefined ? select.options.find(item => item.value == detail.triggerRepurchaseFlag)?.label : '' }}</span>
      </template>
      <template #menu>
        <a-button
          type="primary"
          :disabled="originDetail.guaranteeFlag === detail.guaranteeFlag && originDetail.guaranteeTermNum === detail.guaranteeTermNum && originDetail.triggerRepurchaseFlag === detail.triggerRepurchaseFlag"
          @click="onSave()"
        >保存</a-button>
      </template>
    </DescriptionList>
    <ComplexAutoModal ref="dealer-modal" :optionProps="{ width: 880 }" :menuType="{ target: 'cancel', name: '关闭' }">
      <DealerDetail :id="extraData.orgCustomerid" :extraData="extraData" />
    </ComplexAutoModal>
    <ComplexAutoModal ref="rent-plan-modal" :optionProps="{ width: 880 }" :menuType="{ target: 'cancel', name: '关闭' }">
      <template #default="slotProps">
        <RentPlan :id="id" :width="slotProps.width" :height="slotProps.height" />
      </template>
    </ComplexAutoModal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ComplexAutoModal } from 'complex-component/antd'
import { color } from '../../config'
import overdueApi from '../../api/overdue'
import DescriptionList from './../DescriptionList.vue'
import DealerDetail from './DealerDetail.vue'
import RentPlan from './RentPlan.vue'
import { contractStatus } from '../../select/overdue'
import { dict } from '../../select/dict'
import { notice } from 'complex-plugin'

export default defineComponent({
  name: 'ContractDetail',
  components: {
    DescriptionList,
    DealerDetail,
    RentPlan,
    ComplexAutoModal
  },
  props: {
    id: {
      type: String,
      required: true
    },
    extraData: {
      type: Object,
      required: true
    },
    unOperate: {
      type: Boolean,
      required: false
    },
    defaultCollapse: {
      type: Boolean,
      required: false
    }
  },
  data() {
    const description = [
      {
        name: '项目编号',
        prop: 'projectNo'
      },
      {
        name: '合同编号',
        prop: 'contractNo'
      },
      {
        name: '合同状态',
        prop: 'contractStatus',
        format(value: any) {
          return contractStatus.getItem(value).label as string
        }
      },
      {
        name: '租赁形式',
        prop: 'leaseForm',
        format(value: any) {
          return dict.leas_form.getItem(value).label as string
        }
      },
      {
        name: '业务线',
        prop: 'businessLine',
        format(value: any) {
          return dict.business_lines.getItem(value).label as string
        }
      },
      {
        name: '产品名称',
        prop: 'productName'
      },
      {
        name: '项目日期',
        prop: 'projectDate'
      },
      {
        name: '业务类型',
        prop: 'businessType',
        format(value: any) {
          return dict.business_types.getItem(value).label as string
        }
      },
      {
        name: '放款时间',
        prop: 'loanTime'
      },
      {
        name: '区域经理',
        prop: 'username2'
      },
      {
        name: '经销商',
        prop: 'orgname',
        contentStyle: {
          cursor: 'pointer',
          color: color.link
        },
        click: () => {
          (this.$refs as any)['dealer-modal'].show()
        }
      },
      // "guaranteeFlag":"1",                //类型：String  必有字段  备注：是否担保 1是 0否
      // "guaranteeTermNum":1,                //类型：Number  必有字段  备注：担保期限
      // "triggerRepurchaseFlag":"1",                //类型：String  必有字段  备注：是否触发回购 1是 0否
      {
        name: '是否触发回购',
        prop: 'triggerRepurchaseFlag',
        slot: 'triggerRepurchaseFlag'
      },
      {
        name: '操作',
        prop: 'menu',
        slot: 'menu'
      },
    ]
    if (this.unOperate) {
      description.splice(description.length - 1, 1)
    }
    return {
      collapse: this.defaultCollapse,
      detail: null as any,
      originDetail: {
        guaranteeFlag: undefined as undefined | string,
        guaranteeTermNum: undefined as undefined | number,
        triggerRepurchaseFlag: undefined as undefined | string
      },
      description: description,
      select: {
        options: [
          {
            value: '0',
            label: '否'
          },
          {
            value: '1',
            label: '是'
          },
        ]
      }
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getDetail()
        }
      }
    }
  },
  methods: {
    getDetail() {
      if (this.id) {
        this.detail = null
        overdueApi.overdueContractInfo.require({
          contractId: this.id
        }).then((res) => {
          this.appendDetail(res.data.data)
        })
        overdueApi.overdueContractExtraInfo.require({
          contractId: this.id
        }).then((res) => {
          if (res.data.data) {
            this.originDetail.guaranteeFlag = res.data.data.guaranteeFlag
            this.originDetail.guaranteeTermNum = res.data.data.guaranteeTermNum
            this.originDetail.triggerRepurchaseFlag = res.data.data.triggerRepurchaseFlag
          }
          this.appendDetail(res.data.data)
        })
      }
    },
    appendDetail(data?: Record<PropertyKey, any>) {
      if (data) {
        if (!this.detail) {
          this.detail = {
            ...data
          }
        } else {
          this.detail = {
            ...this.detail,
            ...data
          }
        }
      }
    },
    onSave() {
      overdueApi.changeOverdueContractExtraInfo.require({
        contractId: this.id,
        guaranteeFlag: this.detail.guaranteeFlag,
        guaranteeTermNum: this.detail.guaranteeTermNum,
        triggerRepurchaseFlag: this.detail.triggerRepurchaseFlag
      }).then(() => {
        this.originDetail.guaranteeFlag = this.detail.guaranteeFlag
        this.originDetail.guaranteeTermNum = this.detail.guaranteeTermNum
        this.originDetail.triggerRepurchaseFlag = this.detail.triggerRepurchaseFlag
        notice.showMsg('保存成功!', 'success')
      })
    },
    showRentPlan() {
      (this.$refs as any)['rent-plan-modal'].show('合同租金计划')
    },
    onCollapseChange(value: boolean) {
      this.collapse = value
    }
  }
})
</script>
